/* eslint-disable prettier/prettier */
/* prettier-ignore-file */

import { useState, useEffect, useCallback } from 'react';

import {
	mentoringHoursService,
	LearnerMentoringHoursResponse,
} from '../services/mentoringHoursService';

export const useMentoringHours = (courseid?: string) => {
	const [mentoringHours, setMentoringHours] =
		useState<LearnerMentoringHoursResponse | null>(null);

	const [loading, setLoading] = useState(false);

	const [error, setError] = useState<string | null>(null);

	const fetchMentoringHours = useCallback(async () => {
		try {
			setLoading(true);

			setError(null);

			const data =
				await mentoringHoursService.getLearnerMentoringHours(courseid);

			setMentoringHours(data);
		} catch (err: any) {
			setError(err.message);
		} finally {
			setLoading(false);
		}
	}, [courseid]);

	useEffect(() => {
		fetchMentoringHours();
	}, [fetchMentoringHours]);

	return {
		mentoringHours,

		loading,

		error,

		refetch: fetchMentoringHours,
	};
};
